import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";

export default class TBPService extends ApiService {
  namespace = "to-be-paid";
  DOMAIN = DOMAIN.TO_BE_PAID;
  name = "Payable Credit";
  template = "defaultTemplate";
  Width = 1400;
  icon = "Check";
  showLeftBar = false;
  favicon = "Check";
  singular = this.terminology.tbe.singular;
  plural = this.terminology.tbe.plural;
  vowel = this.terminology.tbe.vowel;

  constructor() {
    super("vendors/payables");
  }
}
